import {
  addRemoveGwpItems,
  getMatchingThemeGwpProducts,
  getMatchingUserInputCode,
  testCartMeetsCollectionPurchaseRequirement,
  testCartMeetsPriceThreshold,
  testCartMeetsProductPurchaseRequirement
} from "./chunk--chunk-27W2WXCH.vbt.js";
import {
  getCartData
} from "./chunk--chunk-AFMX3AIW.vbt.js";
import {
  LOCAL_STORAGE_KEY_GWP_CURRENCY_SYMBOL,
  LOCAL_STORAGE_KEY_GWP_THEME_DATA,
  LOCAL_STORAGE_KEY_GWP_USER_INPUT_CODES,
  PUB_SUB_EVENTS,
  cartDebug,
  getLocalStorage,
  publish,
  setLocalStorage,
  subscribe
} from "./chunk--chunk-UQVRANVK.vbt.js";
import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/GWP.js
var GWP = class {
  constructor(el, sel) {
    this.el = el;
    this.sel = sel;
    let props = el.getAttribute(sel);
    if (props) {
      props = JSON.parse(props);
    } else {
      throw new Error(
        "GWP component used, but its data attribute was not provided necessary props."
      );
    }
    const { graphql_storefront_access_token } = props;
    this.GRAPHQL_ENDPOINT = "/api/2025-07/graphql.json";
    this.STOREFRONT_ACCESS_TOKEN = graphql_storefront_access_token;
    this.els = {
      wrapper: el.querySelector("#gwp-wrapper"),
      codeInput: el.querySelector("#input-gwp-coupon-code"),
      buttonSubmit: el.querySelector("#button-gwp-coupon-code"),
      divStatusMessage: el.querySelector("#status-gwp-coupon-code"),
      buttonRemoveSingleCode: el.querySelector("button#gwp-code-remove-single")
    };
    this.colors = {
      green: "var(--color-green-dark)",
      red: "var(--color-red)",
      grayDark: "var(--color-gray-dark)"
    };
    this.messages = {
      emptyCart: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Please add items to your cart to redeem coupon codes`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      addedNotValidated: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Applying ${codeValue}...`;
        wrapper.style.color = this.colors.green;
        return wrapper;
      },
      invalid: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Sorry, ${codeValue} is not valid`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      validMissingProducts: (codeValue, productsNeededToMeetRequirement, dollarsNeededToReachThresholdString, collectionsNeededToMeetRequirement, requiredPurchasesMustPurchaseAll) => {
        let wrapper = document.createElement("ul");
        wrapper.textContent = `For your free gift with ${codeValue.toUpperCase()}, add ${requiredPurchasesMustPurchaseAll ? "all" : "any"} to your cart: `;
        wrapper.style.color = this.colors.red;
        for (let product of productsNeededToMeetRequirement) {
          let anchorWrapper = document.createElement("li");
          let anchorLink = document.createElement("a");
          anchorLink.textContent = product.name;
          anchorLink.setAttribute("href", product.url);
          anchorLink.style.color = this.colors.grayDark;
          anchorLink.style.textDecoration = "underline";
          anchorWrapper.append(anchorLink);
          wrapper.append(anchorWrapper);
        }
        return wrapper;
      },
      validMissingCollectionProducts: (codeValue, productsNeededToMeetRequirement, dollarsNeededToReachThresholdString, collectionsNeededToMeetRequirement, requiredPurchasesMustPurchaseAll) => {
        let wrapper = document.createElement("ul");
        wrapper.textContent = `For your free gift with ${codeValue.toUpperCase()}, add to your cart an item from ${requiredPurchasesMustPurchaseAll ? "each" : "any"} of these collections: `;
        wrapper.style.color = this.colors.red;
        for (let collection of collectionsNeededToMeetRequirement) {
          let anchorWrapper = document.createElement("li");
          let anchorLink = document.createElement("a");
          anchorLink.textContent = collection.name;
          anchorLink.setAttribute("href", collection.url);
          anchorLink.style.color = this.colors.grayDark;
          anchorLink.style.textDecoration = "underline";
          anchorWrapper.append(anchorLink);
          wrapper.append(anchorWrapper);
        }
        return wrapper;
      },
      validBelowThreshold: (codeValue, productsNeededToMeetRequirement, dollarsNeededToReachThresholdString) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Add ${getLocalStorage(LOCAL_STORAGE_KEY_GWP_CURRENCY_SYMBOL) ?? "$"}${dollarsNeededToReachThresholdString} to your cart for your free gift with ${codeValue.toUpperCase()}`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      validApplied: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Free gift added for ${codeValue}`;
        wrapper.style.color = this.colors.green;
        return wrapper;
      },
      removed: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Removed ${codeValue}`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      removedEmptyCart: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Removed ${codeValue}. Please add items to your cart to redeem coupon codes.`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      // for Shopify Discounts only
      validAppliedShopifyDiscount: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `${codeValue} applied to cart`;
        wrapper.style.color = this.colors.green;
        return wrapper;
      },
      invalidShopifyDiscount: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `${codeValue} isn't valid for the items in your cart`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      }
    };
    this.codeStatus = {
      addedNotValidated: "addedNotValidated",
      invalid: "invalid",
      validMissingProducts: "validMissingProducts",
      validMissingCollectionProducts: "validMissingCollectionProducts",
      validBelowThreshold: "validBelowThreshold",
      validApplied: "validApplied",
      removed: "removed",
      removedEmptyCart: "removedEmptyCart",
      // potential future status, if allow multiple codes;
      validReplaced: "validReplaced"
    };
    this.persistentStatuses = [
      this.codeStatus.validApplied,
      this.codeStatus.validMissingProducts,
      this.codeStatus.validMissingCollectionProducts,
      this.codeStatus.validBelowThreshold
    ];
    this.timeoutMessageReset = false;
    this.resetMessageAfterMs = 5e3;
    this.fakeHashForShopifyDiscountCodes = "SHOPIFY_DISCOUNT_CODE";
    this.activeShopifyDiscountCode = void 0;
    this.shopifyDiscountsRemoveCode = "''";
    this.callbackTimeout = null;
    this.callbackTriggers = 0;
    this.handleRemoveCodeWithParams = null;
  }
  /**
   *
   * Generic helpers
   *
   */
  async sha256(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
    return hashHex;
  }
  async getCodeHash(codeValue) {
    return codeValue.trim() !== "" ? await this.sha256(codeValue.toUpperCase()) : "";
  }
  /**
   *
   * Shopify Discounts helpers
   *
   */
  // apply Shopify Discount code to cart
  // https://community.shopify.com/c/technical-q-a/applying-discount-codes-in-the-cart-prior-to-checkout/m-p/800576
  async applyDiscountCode(code) {
    try {
      await fetch(`/checkout?discount=${code}`, { mode: "no-cors" });
    } catch (err) {
      throw err;
    }
  }
  async removeDiscountCodes() {
    try {
      await this.applyDiscountCode(this.shopifyDiscountsRemoveCode);
    } catch (err) {
      throw err;
    }
  }
  // cart object: https://shopify.dev/docs/api/storefront/2024-07/objects/Cart
  // https://shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/cart/manage
  async getCartDiscountCodes(cartId) {
    try {
      let res = await fetch(this.GRAPHQL_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({
          query: `query getCart($id: ID!) {
            cart(id: $id) {
              id
              createdAt
              updatedAt
              discountCodes {
                applicable
                code
              }
            }
          }`,
          variables: `{
            "id": "gid://shopify/Cart/${cartId}"
          }`
        })
      });
      let json = await res.json();
      cartDebug({ json });
      let discountCodes = json?.data?.cart?.discountCodes;
      return discountCodes;
    } catch (err) {
      throw err;
    }
  }
  // use cached cart state with staleness check; use for getCartId(), getCartData(), getCartDiscountCodes();
  // borrow staleness code from SkinQuiz; does Shopify return any cart value that could be used as a check (akin to mongodb incrementing a value every time a resource is updated)?
  // consider failsafes/bail outs (again, like in Skin Quiz): will want to check for high level structure of data (for some assurance it's accurate); I suppose the cleanest bail out is a short staleness threshold, which should be fine (esp. if also update localStorage val on every cart check, even when updates aren't made): either a user is actively using the site or they've walked away, after which point a one-time re-check is acceptable;
  // get id of current cart, use it to retrieve discount codes applied to cart;
  async getCartIdAndDiscountCodes(cartId) {
    try {
      if (cartId) {
        let discountCodes = await this.getCartDiscountCodes(cartId);
        return discountCodes;
      } else {
        return [];
      }
    } catch (err) {
      console.error(err);
    }
  }
  async applyTestShopifyDiscount(gwpInputVal, cartId) {
    try {
      cartDebug("applyTestShopifyDiscount");
      await this.applyDiscountCode(gwpInputVal);
      cartDebug(
        "applied Shopify Discounts code, now checking if it was applied"
      );
      let isApplicableDiscountCode = await this.checkDiscountCodes(cartId);
      return isApplicableDiscountCode;
    } catch (err) {
      throw err;
    }
  }
  /**
   *
   * Component-specific helpers
   *
   */
  getThemeGwpData() {
    return getLocalStorage(LOCAL_STORAGE_KEY_GWP_THEME_DATA) ?? [];
  }
  getUserInputCodes() {
    return getLocalStorage(LOCAL_STORAGE_KEY_GWP_USER_INPUT_CODES) ?? [];
  }
  setUserInputCodes(val) {
    setLocalStorage(LOCAL_STORAGE_KEY_GWP_USER_INPUT_CODES, val);
  }
  updateStatusMessage(el, resetMessage) {
    clearTimeout(this.timeoutMessageReset);
    this.els.divStatusMessage.replaceChildren(el);
    if (resetMessage) {
      this.timeoutMessageReset = setTimeout(() => {
        this.updateStatusMessage(resetMessage);
      }, this.resetMessageAfterMs);
    }
  }
  async handleRemoveDiscountCode(codeValue, messageType = "removed") {
    cartDebug("handleRemoveDiscountCode");
    try {
      await this.removeDiscountCodes();
      this.updateStatusMessage(
        this.messages[messageType](codeValue, void 0, void 0)
      );
      this.activeShopifyDiscountCode = void 0;
      publish(PUB_SUB_EVENTS.cartUpdateRequest, {
        variantQuantityMap: {}
      });
    } catch (err) {
      throw err;
    }
  }
  handleRemoveGwpCode(codeObj) {
    try {
      this.removeCode(codeObj);
      this.updateUIAppliedCodes();
    } catch (err) {
      throw err;
    }
  }
  updateInput(codeToShowInInput) {
    let gwpInput = this.el.querySelector("#input-gwp-coupon-code");
    const resetInput = () => {
      gwpInput.disabled = false;
      gwpInput.value = "";
      this.disableSubmitButton();
      this.els.buttonRemoveSingleCode.classList.add("hidden");
      this.els.buttonRemoveSingleCode.removeEventListener(
        "click",
        // testPerfHandleRemoveCode,
        // handleRemoveCode,
        this.handleRemoveCodeWithParams
      );
    };
    const handleRemoveCode = async (codeToShowInInput2) => {
      try {
        if (codeToShowInInput2.codeHash === this.fakeHashForShopifyDiscountCodes) {
          await this.handleRemoveDiscountCode(
            codeToShowInInput2.codeValue,
            "removed"
          );
        } else {
          this.handleRemoveGwpCode(codeToShowInInput2);
        }
        resetInput();
      } catch (err) {
        console.error(err);
      }
    };
    if (codeToShowInInput) {
      this.els.buttonRemoveSingleCode.removeEventListener(
        "click",
        // testPerfHandleRemoveCode,
        // () => this.handleRemoveCode(codeToShowInInput),
        this.handleRemoveCodeWithParams
      );
      this.handleRemoveCodeWithParams = () => handleRemoveCode(codeToShowInInput);
      this.disableSubmitButton();
      gwpInput.disabled = true;
      gwpInput.value = codeToShowInInput.codeValue;
      this.els.buttonRemoveSingleCode.classList.remove("hidden");
      this.els.buttonRemoveSingleCode.addEventListener(
        "click",
        // testPerfHandleRemoveCode,
        // () => this.handleRemoveCode(codeToShowInInput),
        this.handleRemoveCodeWithParams
      );
    } else {
      resetInput();
    }
  }
  /**
   *
   * Core methods
   *
   */
  removeItemArrayFromCart(variantIdArray) {
    let updates = variantIdArray.reduce((prev, curr) => {
      return {
        ...prev,
        [curr]: 0
      };
    }, {});
    publish(PUB_SUB_EVENTS.cartUpdateRequest, {
      variantQuantityMap: updates
    });
  }
  removeGiftProducts(codeObj) {
    const productsToRemove = getMatchingThemeGwpProducts(codeObj, "id");
    cartDebug({ productsToRemove });
    if (productsToRemove.length > 0) {
      this.removeItemArrayFromCart(
        productsToRemove.map((product) => product.variantId)
      );
    }
  }
  // marks code as "removed" and updates UI and cart accordingly; does not remove from localStorage, which allows persistence of status message after page reload, and may offer benefits to future features;
  removeCode(codeObj) {
    const { codeValue, codeHash } = codeObj;
    const codeToBeRemoved = getMatchingUserInputCode(codeObj);
    let codeStatusBeforeRemoval = codeToBeRemoved?.status;
    this.addUpdateUserCode({
      codeValue,
      codeHash,
      status: this.codeStatus.removed
    });
    if (codeStatusBeforeRemoval === this.codeStatus.validApplied) {
      this.removeGiftProducts(codeObj);
    }
  }
  updateUIAppliedCodes(allowMultipleCodes = false) {
    let userInputCodes = this.getUserInputCodes();
    if (allowMultipleCodes) {
    } else {
      let lastUpdatedCode = userInputCodes[0];
      if (lastUpdatedCode) {
        let {
          codeValue,
          codeHash,
          status,
          productsNeededToMeetRequirement,
          dollarsNeededToReachThresholdString,
          collectionsNeededToMeetRequirement,
          requiredPurchasesMustPurchaseAll
        } = lastUpdatedCode;
        if (this.persistentStatuses.includes(status)) {
          this.updateStatusMessage(
            this.messages[status](
              codeValue,
              productsNeededToMeetRequirement,
              dollarsNeededToReachThresholdString,
              collectionsNeededToMeetRequirement,
              requiredPurchasesMustPurchaseAll
            )
          );
        } else if (Date.now() - lastUpdatedCode.timeUpdated < this.resetMessageAfterMs) {
          this.updateStatusMessage(
            this.messages[status](
              codeValue,
              productsNeededToMeetRequirement,
              dollarsNeededToReachThresholdString,
              collectionsNeededToMeetRequirement,
              requiredPurchasesMustPurchaseAll
            )
          );
        }
      }
      let codeToShowInInput = userInputCodes.find(
        (codeObj) => this.persistentStatuses.includes(codeObj.status)
      );
      this.updateInput(codeToShowInInput);
    }
  }
  addUpdateUserCode(codeObj) {
    const { codeValue, codeHash, status } = codeObj;
    codeObj.timeUpdated = Date.now();
    let userInputCodes = this.getUserInputCodes();
    let updatedUserInputCodes = [...userInputCodes];
    if (status === this.codeStatus.validApplied) {
      for (let thisCodeObj of updatedUserInputCodes) {
        if (thisCodeObj.codeStatus === this.codeStatus.validApplied) {
          thisCodeObj.codeStatus = this.codeStatus.validReplaced;
        }
      }
    }
    let codeToUpdateIndex = updatedUserInputCodes.findIndex(
      (val) => val.codeValue === codeValue && val.codeHash === codeHash
    );
    if (codeToUpdateIndex > -1) {
      cartDebug("User-input code exists; updating its entry in userInputCodes");
      let codeToUpdate = updatedUserInputCodes.splice(codeToUpdateIndex, 1)[0];
      updatedUserInputCodes = [
        { ...codeToUpdate, ...codeObj },
        ...updatedUserInputCodes
      ];
    } else {
      cartDebug("User-input is new; adding to userInputCodes");
      codeObj.timeAdded = Date.now();
      updatedUserInputCodes = [codeObj, ...updatedUserInputCodes];
    }
    this.setUserInputCodes(updatedUserInputCodes);
    return codeObj;
  }
  getCodeStatus(codeObj, cartData) {
    const { codeValue, codeHash, status } = codeObj;
    const { cartRaw, cartItemVariantIds, cartTotalPrice } = cartData;
    if (status === this.codeStatus.removed || status === this.codeStatus.removedEmptyCart || status === this.codeStatus.invalid) {
      cartDebug(
        "GWP code is invalid or was removed; returning data as-is",
        codeObj
      );
      return codeObj;
    }
    const matchingThemeGwpProducts = getMatchingThemeGwpProducts(
      codeObj,
      "hash"
    );
    cartDebug({ matchingThemeGwpProducts });
    const gwpInputValThemeMatch = matchingThemeGwpProducts[0];
    if (!gwpInputValThemeMatch) {
      cartDebug("GWP code does not match any in theme settings", codeObj);
      return {
        status: this.codeStatus.invalid,
        productsNeededToMeetRequirement: void 0,
        dollarsNeededToReachThresholdString: void 0,
        collectionsNeededToMeetRequirement: void 0,
        requiredPurchasesMustPurchaseAll: void 0
      };
    }
    if (cartTotalPrice === 0) {
      cartDebug("Cart is empty; rejecting GWP");
      return {
        status: this.codeStatus.removedEmptyCart,
        productsNeededToMeetRequirement: void 0,
        dollarsNeededToReachThresholdString: void 0,
        collectionsNeededToMeetRequirement: void 0,
        requiredPurchasesMustPurchaseAll: void 0
      };
    }
    const {
      gwpId,
      requiredProductPurchases,
      requiredCollectionPurchases,
      requiredPurchasesMustPurchaseAll,
      threshold
    } = gwpInputValThemeMatch;
    if (requiredProductPurchases.length > 0) {
      let {
        doesMeetProductPurchaseRequirement,
        productsNeededToMeetRequirement
      } = testCartMeetsProductPurchaseRequirement(
        requiredProductPurchases,
        cartItemVariantIds,
        requiredPurchasesMustPurchaseAll
      );
      if (!doesMeetProductPurchaseRequirement) {
        cartDebug(
          "GWP code does not meet product purchase requirement",
          codeObj
        );
        return {
          gwpId,
          status: this.codeStatus.validMissingProducts,
          productsNeededToMeetRequirement,
          dollarsNeededToReachThresholdString: void 0,
          collectionsNeededToMeetRequirement: void 0,
          requiredPurchasesMustPurchaseAll
        };
      }
    }
    if (requiredCollectionPurchases.length > 0) {
      let {
        doesMeetCollectionPurchaseRequirement,
        collectionsNeededToMeetRequirement
      } = testCartMeetsCollectionPurchaseRequirement(
        requiredCollectionPurchases,
        cartItemVariantIds,
        requiredPurchasesMustPurchaseAll
      );
      cartDebug({
        doesMeetCollectionPurchaseRequirement,
        collectionsNeededToMeetRequirement
      });
      if (!doesMeetCollectionPurchaseRequirement) {
        cartDebug(
          "GWP code does not meet collection purchase requirement",
          codeObj
        );
        return {
          gwpId,
          status: this.codeStatus.validMissingCollectionProducts,
          productsNeededToMeetRequirement: void 0,
          dollarsNeededToReachThresholdString: void 0,
          collectionsNeededToMeetRequirement,
          requiredPurchasesMustPurchaseAll
        };
      }
    }
    let { doesMeetThreshold, dollarsNeededToReachThresholdString } = testCartMeetsPriceThreshold(threshold, cartTotalPrice);
    if (!doesMeetThreshold) {
      cartDebug("GWP code does not meet price threshold requirement", codeObj);
      return {
        gwpId,
        status: this.codeStatus.validBelowThreshold,
        productsNeededToMeetRequirement: void 0,
        dollarsNeededToReachThresholdString,
        collectionsNeededToMeetRequirement: void 0,
        requiredPurchasesMustPurchaseAll
      };
    }
    cartDebug("GWP code is valid and applied", codeObj);
    return {
      gwpId,
      status: this.codeStatus.validApplied,
      productsNeededToMeetRequirement: void 0,
      dollarsNeededToReachThresholdString: void 0,
      collectionsNeededToMeetRequirement: void 0,
      requiredPurchasesMustPurchaseAll
    };
  }
  testCodeValidity(codeObj, cartData) {
    const {
      codeValue,
      codeHash,
      status,
      productsNeededToMeetRequirement,
      dollarsNeededToReachThresholdString,
      collectionsNeededToMeetRequirement,
      requiredPurchasesMustPurchaseAll
    } = codeObj;
    const updatedStatus = this.getCodeStatus(codeObj, cartData);
    if (updatedStatus.status !== status || updatedStatus.productsNeededToMeetRequirement !== productsNeededToMeetRequirement || updatedStatus.collectionsNeededToMeetRequirement !== collectionsNeededToMeetRequirement || updatedStatus.dollarsNeededToReachThresholdString !== dollarsNeededToReachThresholdString) {
      return this.addUpdateUserCode({
        codeValue,
        codeHash,
        ...updatedStatus
      });
    } else {
      return codeObj;
    }
  }
  testAllAddedCodes(userInputCodes, cartData) {
    cartDebug("testAllAddedCodes");
    const GWP_CODES_MAX_ALLOWED = 1;
    let gwpCodesValidAppliedCount = 0;
    for (let codeObj of userInputCodes) {
      let testedCodeObj = this.testCodeValidity(codeObj, cartData);
      if (testedCodeObj.status === this.codeStatus.validApplied) {
        gwpCodesValidAppliedCount += 1;
        if (gwpCodesValidAppliedCount > GWP_CODES_MAX_ALLOWED) {
          this.removeCode(testedCodeObj);
        }
      }
    }
  }
  updateCartGwp = async (cartData) => {
    addRemoveGwpItems(cartData);
  };
  async applyTestGwpCode(codeValue, cartData) {
    try {
      var codeHash = await this.getCodeHash(codeValue);
      let savedCodeObj = this.addUpdateUserCode({
        codeValue,
        codeHash,
        status: this.codeStatus.addedNotValidated
      });
      let testedCodeObj = this.testCodeValidity(savedCodeObj, cartData);
      if (testedCodeObj.status === this.codeStatus.validApplied) {
        return true;
      }
      return false;
    } catch (err) {
      throw err;
    }
  }
  async handleSubmitCode() {
    try {
      this.disableSubmitButton();
      let inputCode = this.els.codeInput;
      let codeValue = inputCode.value.toUpperCase();
      let cartData = await getCartData();
      if (cartData.cartTotalPrice === 0) {
        this.updateStatusMessage(this.messages.emptyCart());
        inputCode.value = "";
        return;
      }
      let isApplicableGwpCode = await this.applyTestGwpCode(
        codeValue,
        cartData
      );
      if (isApplicableGwpCode) {
        this.updateUIAppliedCodes();
        this.updateCartGwp(cartData);
        return;
      }
      let isApplicableDiscountCode = await this.applyTestShopifyDiscount(
        codeValue,
        cartData?.cartRaw?.token
      );
      if (isApplicableDiscountCode) {
        publish(PUB_SUB_EVENTS.cartUpdateRequest, {
          variantQuantityMap: {}
        });
        return;
      }
      this.updateUIAppliedCodes();
    } catch (err) {
      console.error(err);
      this.enableSubmitButton();
      throw err;
    }
  }
  disableSubmitButton() {
    let gwpSubmitBtn = this.els.buttonSubmit;
    gwpSubmitBtn.classList.add("opacity-50");
    gwpSubmitBtn.disabled = true;
  }
  enableSubmitButton() {
    let gwpSubmitBtn = this.els.buttonSubmit;
    gwpSubmitBtn.classList.remove("opacity-50");
    gwpSubmitBtn.disabled = false;
  }
  async testPerformance(testFunc, funcName, iterations = 1) {
    console.time(funcName);
    for (var i = 0; i < iterations; i++) {
      await testFunc();
    }
    const LOG_STYLES_PERF = "color: #fff; font-size: 1.0rem; background-color: red; padding: 4px";
    console.log(`%cPerformance ${funcName}`, LOG_STYLES_PERF);
    console.timeEnd(funcName);
  }
  addEventListeners(el) {
    let gwpSubmitBtn = this.els.buttonSubmit;
    gwpSubmitBtn.addEventListener("click", () => {
      try {
        this.handleSubmitCode();
      } catch (err) {
        console.error(err);
      }
    });
    let gwpInput = this.els.codeInput;
    ["input", "change", "keypress"].forEach((eventType) => {
      gwpInput?.addEventListener(eventType, (e) => {
        const inputVal = e.currentTarget.value;
        if (eventType === "keypress") {
          if (e.code === "Enter") {
            e.preventDefault();
            try {
              if (inputVal.trim() !== "") {
                this.handleSubmitCode();
              }
            } catch (err) {
              console.error(err);
            }
            return;
          }
        }
        if (inputVal.trim() !== "") {
          this.enableSubmitButton();
        } else {
          this.disableSubmitButton();
        }
      });
    });
  }
  async testCodesUpdateUI() {
    cartDebug("testCodesUpdateUI");
    let cartData = await getCartData();
    if (!cartData) {
      console.error("GWP - no cart data found");
      return;
    }
    let isApplicableDiscountCode = await this.checkDiscountCodes(
      cartData?.cartRaw?.token
    );
    if (isApplicableDiscountCode) {
      return;
    }
    this.testAllAddedCodes(this.getUserInputCodes(), cartData);
    this.updateUIAppliedCodes();
  }
  isValidCodePresent() {
    if (this.activeShopifyDiscountCode) {
      return true;
    }
    let userInputCodes = this.getUserInputCodes();
    let validCode = userInputCodes.find(
      (codeObj) => this.persistentStatuses.includes(codeObj.status)
    );
    if (validCode) {
      return true;
    }
    return false;
  }
  async checkDiscountCodes(cartId) {
    cartDebug("checkDiscountCodes", cartId);
    try {
      let cartDiscountCodes = await this.getCartIdAndDiscountCodes(cartId);
      cartDebug({ cartId, cartDiscountCodes });
      if (cartDiscountCodes && cartDiscountCodes.length > 0) {
        let firstApplicableCode = cartDiscountCodes.find(
          (val) => val.applicable
        );
        if (firstApplicableCode) {
          let userInputCodes = this.getUserInputCodes();
          for (let eachCode of userInputCodes) {
            if (eachCode.status === this.codeStatus.validApplied || eachCode.status === this.codeStatus.validMissingProducts || eachCode.status === this.codeStatus.validBelowThreshold) {
              this.removeCode(eachCode);
            }
          }
          this.updateInput({
            codeValue: firstApplicableCode.code,
            codeHash: this.fakeHashForShopifyDiscountCodes
          });
          this.updateStatusMessage(
            this.messages.validAppliedShopifyDiscount(firstApplicableCode.code)
          );
          this.activeShopifyDiscountCode = firstApplicableCode.code;
          return true;
        } else {
        }
      }
      if (this.activeShopifyDiscountCode) {
        this.handleRemoveDiscountCode(
          this.activeShopifyDiscountCode,
          "invalidShopifyDiscount"
        );
      } else if (cartDiscountCodes?.[0] && cartDiscountCodes !== this.shopifyDiscountsRemoveCode) {
        this.removeDiscountCodes();
      }
      return false;
    } catch (err) {
      throw err;
    }
  }
  unhide() {
    let themeData = this.getThemeGwpData();
    if (themeData.length > 0) {
      this.els.wrapper.style.display = "block";
    }
  }
  async init() {
    try {
      await this.testCodesUpdateUI();
      subscribe(
        PUB_SUB_EVENTS.cartMutationComplete,
        () => {
          this.testCodesUpdateUI();
        },
        "gwp_testCodesUpdateUI"
      );
      this.addEventListeners(this.el);
    } catch (err) {
      console.error(err);
    }
  }
};
var GWP_default = GWP;
export {
  GWP_default as default
};
